import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { adviceI18nKeyTemplate, EnvironmentToken, I18nKeys } from '@jump-tech-frontend/app-config';

interface I18nKeysOut {
  [key: string]: string | object;
}

@Injectable({
  providedIn: 'root'
})
export class CardsLibTranslationService {
  /*
  initialize i18ns with all the object keys so the compiler can catch
  new keys added to I18nKeys interface (Cards lib)
   */

  i18nKeys: I18nKeys = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    cameraTakePhoto: '',
    cameraCancel: '',
    cameraPhotosAndFiles: '',
    cameraTorchOn: '',
    cameraTorchOff: '',
    cameraStarting: '',
    cameraTurningLightOn: '',
    cameraCapturing: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    dataLogging: {
      label: '',
      hint: ''
    },
    video: {
      confirmDeletion: '',
      record: '',
      maximumLengthHint: '',
      recordingFailed: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    },
    aiValidation: {
      remove: '',
      quality: '',
      detection: '',
      warnings: '',
      dimensions: '',
      overallScore: '',
      sharpness: '',
      exposure: '',
      resolution: '',
      issues: '',
      equipmentType: '',
      confidence: '',
      boundingBoxes: '',
      show: '',
      hide: '',
      showBoundingBoxes: '',
      hideBoundingBoxes: '',
      imageSize: '',
      sourceSize: '',
      validationSuccessful: '',
      qualityIssues: '',
      lowConfidence: '',
      wrongEquipment: '',
      noDetection: '',
      validating: '',
      validationFailed: '',
      imageValidationSuccessful: '',
      imageQualityIssues: '',
      lowConfidenceDetection: '',
      wrongEquipmentDetected: '',
      noEquipmentDetected: '',
      imageValidationInProgress: '',
      imageValidationFailed: '',
      equipmentDetectedSuccessfully: '',
      imageTooLowQuality: '',
      equipmentDetectedLowConfidence: '',
      noEquipmentInImage: '',
      analyzingImage: '',
      validationFailedMessage: '',
      qualityCheckingImage: '',
      equipmentFound: '',
      qualityTooLowMessage: '',
      lowConfidenceMessage: '',
      noEquipmentDetectedMessage: '',
      validationFailedFor: '',
      confidenceWarning: '',
      reassuranceMessage: '',
      qualityIssuesLabel: '',
      detectionIssuesLabel: '',
      fuseCutout: '',
      consumerUnit: '',
      isolatorSwitch: '',
      unknown: '',
      equipment: '',
      failedToValidateImage: '',
      advice: adviceI18nKeyTemplate()
    }
  };

  i18ns: I18nKeysOut = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    cameraTakePhoto: '',
    cameraCancel: '',
    cameraPhotosAndFiles: '',
    cameraTorchOn: '',
    cameraTorchOff: '',
    cameraStarting: '',
    cameraTurningLightOn: '',
    cameraCapturing: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    dataLogging: {
      label: '',
      hint: ''
    },
    video: {
      confirmDeletion: '',
      record: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    },
    aiValidation: {
      remove: '',
      quality: '',
      detection: '',
      warnings: '',
      dimensions: '',
      overallScore: '',
      sharpness: '',
      exposure: '',
      resolution: '',
      issues: '',
      equipmentType: '',
      confidence: '',
      boundingBoxes: '',
      show: '',
      hide: '',
      showBoundingBoxes: '',
      hideBoundingBoxes: '',
      imageSize: '',
      sourceSize: '',
      validationSuccessful: '',
      qualityIssues: '',
      lowConfidence: '',
      wrongEquipment: '',
      noDetection: '',
      validating: '',
      validationFailed: '',
      imageValidationSuccessful: '',
      imageQualityIssues: '',
      lowConfidenceDetection: '',
      wrongEquipmentDetected: '',
      noEquipmentDetected: '',
      imageValidationInProgress: '',
      imageValidationFailed: '',
      equipmentDetectedSuccessfully: '',
      imageTooLowQuality: '',
      equipmentDetectedLowConfidence: '',
      noEquipmentInImage: '',
      analyzingImage: '',
      validationFailedMessage: '',
      qualityCheckingImage: '',
      equipmentFound: '',
      qualityTooLowMessage: '',
      lowConfidenceMessage: '',
      noEquipmentDetectedMessage: '',
      validationFailedFor: '',
      confidenceWarning: '',
      reassuranceMessage: '',
      qualityIssuesLabel: '',
      detectionIssuesLabel: '',
      fuseCutout: '',
      consumerUnit: '',
      isolatorSwitch: '',
      unknown: '',
      equipment: '',
      failedToValidateImage: '',
      advice: adviceI18nKeyTemplate()
    }
  };

  constructor(
    private translocoService: TranslocoService,
    @Inject(EnvironmentToken) private environment: any
  ) {}

  loadTranslations() {
    this.i18ns = this.loadTranslationParts(this.i18nKeys);
    if (!this.environment.production) {
      console.log('\x1b[34m%s\x1b[0m', 'Cards Library translations: ', this.i18ns);
    }
    return this.i18ns as unknown as I18nKeys;
  }

  private loadTranslationParts(keys: I18nKeys, path: string = null) {
    Object.keys(keys).map((k: string) => {
      if (typeof keys[k] === 'string') {
        keys[k] = this.translocoService.translate(path ? `_commons.${path}.${k}` : `_commons.${k}`);
      } else {
        if (!keys?.[keys?.[k]]) {
          keys[keys[k]] = {};
        }
        this.loadTranslationParts(keys[k], path ? `${path}.${k}` : k);
      }
    });
    return keys as unknown as I18nKeysOut;
  }
}
